import { getClauseById } from "@/api";
import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { useMountEffect } from "@react-hookz/web";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { ClauseExamplesSection } from "./components/clause-details/ClauseExamplesSection";
import { ClauseInfoSection } from "./components/clause-details/ClauseInfoSection";
import { ClauseSectionTypesSection } from "./components/clause-details/ClauseSectionTypesSection";

/**
 * The details page for an admin clause.
 */
const AdminClauseDetails = () => {
    const { clauseId } = useParams();
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Clause");

    const { data: clause } = useSuspenseQuery({
        queryKey: ["admin-clause-details", clauseId],
        queryFn: () => getClauseById(Number(clauseId)),
    });

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Clauses", path: "clauses" },
            { label: clause.title },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title={clause.title}
                subtitle="Definition, examples, and section type mappings"
            />
            <Stack spacing={3} pb={2} className="mt-6">
                <ClauseInfoSection clause={clause} />
                <ClauseExamplesSection clause={clause} />
                <ClauseSectionTypesSection clauseId={clause.id} />
            </Stack>
        </AdminPageContent>
    );
};

export default AdminClauseDetails;
